"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { Icon } from "@/components/ui/icon";
import { process } from "@/lib/data/homepage";

/**
 * Process — 6 phases as a continuous workflow with circular arrows,
 * week labels, and color-coded phase markers.
 */
export function Process() {
  return (
    <section id="process" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-denim)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-denim)]" />
            The Process
          </span>
          <h2 className="mt-6">
            The Perception X2 Methodology
          </h2>
          <p className="mt-4 text-body leading-relaxed text-[rgb(var(--fg-muted))] max-w-2xl mx-auto">
            Six phases that ensure systematic, measurable perception transformation.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {process.map((p, i) => {
            const accent = ["var(--color-cyan)", "var(--color-emerald)", "var(--color-purple)", "var(--color-amber)", "var(--color-crimson)", "var(--color-denim)"][i];
            return (
              <Reveal key={p.title} delay={i * 60}>
                <div
                  className="rounded-2xl glass p-5 h-full relative overflow-hidden card-glow group"
                  style={{ ["--glow" as string]: accent }}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <span
                      className="grid place-items-center h-9 w-9 rounded-lg shrink-0 transition-transform group-hover:scale-110"
                      style={{
                        background: `color-mix(in oklch, ${accent} 18%, transparent)`,
                        boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                      }}
                    >
                      <Icon name={p.icon} className="h-4 w-4" style={{ color: accent }} />
                    </span>
                    <div>
                      <div className="eyebrow-tiny font-bold" style={{ color: accent }}>
                        {p.week}
                      </div>
                      <h3 className="text-base font-bold leading-tight">{p.title}</h3>
                    </div>
                  </div>
                  <p className="text-body-xs leading-relaxed text-[rgb(var(--fg-muted))]">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
